module.exports = __webpack_public_path__ + "img/228.ba2e596a.jpg";